import * as _ from 'underscore';

import { RefreshContentScope } from '../../app/ActionPlaceScopes';
import { appStore } from '../../app/AppStore';
import { IActionContext } from '../helpers/ActionContext';
import { CommonErrorCode } from '../helpers/ErrorCodes';
import { IDataConnectionInfo } from '../models/IDataConnectionInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConnectionEditabilityHelper, EditConnectionAction } from './EditConnectionAction';

// Action Interfaces

export interface IActionButton<TSummary, TDetail> {
  name: string;
  translate?: string;
  isAvailable(items: Set<TSummary>, detailedItem?: TDetail, allowedActions?: any): boolean;
  isDisabled?(items: Set<TSummary>, detailedItem?: TDetail, allowedActions?: any): boolean;
  execute(items: Set<TSummary>, context: IActionContext, detailedItem?: TDetail): void;
}

export interface IListActionButton {
  name: string;
  translate?: string;
  isAvailable(): boolean;
  execute($event: JQueryEventObject): void;
}

/**
 * This class contains actions designed to be used in the actions menu.
 *
 * TODO: Rename this class. It's called ActionPanelService because before the actions menu,
 *       there was a panel where actions were executed.
 */
export class ActionPanelService {

  public static $inject = [
    'EditConnectionAction',
  ];

  private DataConnectionActions: IActionButton<IDataConnectionInfo, {}>[];

  constructor(
    private EditConnectionAction: EditConnectionAction
    ) {
    this.DataConnectionActions = [
      this.editDataConnectionAction(),
    ];
  }

  public getDataConnectionActions() {
    return this.DataConnectionActions;
  }

  // Helper functions

  public static anySelected<T>(items: Set<T>): boolean {
    return items.size() > 0;
  }


  private editDataConnectionAction(): IActionButton<IDataConnectionInfo, {}> {
    return {
      name: 'edit-connection',
      translate: 'editConnection_action',
      isAvailable: ActionPanelService.anySelected,
      isDisabled: (dataConnections: Set<IDataConnectionInfo>) =>
        dataConnections.size() === 1 &&
          !ConnectionEditabilityHelper.userCanEditConnection(dataConnections.first(), appStore.getState()),
      execute: (dataConnections: Set<IDataConnectionInfo>, context: IActionContext) => {
        const scope = <RefreshContentScope>context.scope;
        this.EditConnectionAction.confirmEditConnections(dataConnections.toArray(), context)
          .then((result: IResult) => {
            ActionHelpers.deselectNotFound(dataConnections, result, CommonErrorCode.DataConnectionNotFound);
            scope.refreshContent();
          });
      }
    };
  }
}

Module.instance().service('ActionPanelService', ActionPanelService);
